import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import Modal from '../../../components/Modal/Modal';
import Login from '../../../components/Login/Login';
import {
  buildPurchaseOnboardingRegistrationUrl,
  formatPurchaseAmountWithCode,
  getPurchaseLineTotal,
  isPurchaseSignedIn,
  PURCHASE_SIGNED_IN_SUCCESS_PATH,
} from '../purchaseHelpers';

export default function PurchaseSuccess({ plan, quantity, email, captureResult, preAuth = false }) {
  const total = plan ? getPurchaseLineTotal(plan, quantity) : null;
  const subscriptionKeys = captureResult?.subscriptionKeys || [];
  const purchaserEmail = captureResult?.customerEmail || email;
  const onboardingUrl = buildPurchaseOnboardingRegistrationUrl({
    subscriptionKeys,
    email: purchaserEmail,
    userType: 2,
  });
  const signedIn = isPurchaseSignedIn();
  const goToPlanDashboard = preAuth || signedIn;

  return (
    <div className="purchase-success">
      <div className="purchase-success-icon" aria-hidden="true">
        ✓
      </div>
      <h2 className="purchase-success-title">Payment successful</h2>
      <p className="purchase-success-copy">
        Thank you. Your payment has been confirmed and subscription details will be sent to{' '}
        <strong>{purchaserEmail}</strong>.
      </p>

      {plan ? (
        <p className="purchase-success-detail">
          {plan.name} · qty {quantity} · {formatPurchaseAmountWithCode(total, plan.currencyCode, plan.currencySymbol)}
        </p>
      ) : null}

      {subscriptionKeys.length > 0 ? (
        <div className="purchase-success-keys">
          <p className="purchase-success-keys-label">Subscription keys</p>
          <ul>
            {subscriptionKeys.map((key) => (
              <li key={key}>
                <code>{key}</code>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      <div className="purchase-success-actions">
        {goToPlanDashboard ? (
          <Button type="primary" className="purchase-success-btn">
            <Link to={PURCHASE_SIGNED_IN_SUCCESS_PATH}>Go to plan dashboard</Link>
          </Button>
        ) : (
          <Button type="primary" className="purchase-success-btn">
            <Link to={onboardingUrl}>Continue onboarding</Link>
          </Button>
        )}
        {!signedIn ? (
          <Modal
            toggle={(show) => (
              <Button className="purchase-success-btn" onClick={show}>
                Log in
              </Button>
            )}
          >
            {(hide) => <Login close={hide} />}
          </Modal>
        ) : null}
        <Button className="purchase-success-btn">
          <Link to="/purchase">Buy more plans</Link>
        </Button>
      </div>
    </div>
  );
}
